// This will have to be refactored with DOWGP-2776 or some BS-___ Ticket
export enum LookupTypeDomains {
    SalesPeriodType = 1,
    AttachmentStatusType = 2,
    TemplateType = 3,
    baseInvoiceType = 4,
    lineItemType = 5
}

export class AppConsts {

    static readonly localStorageNodeStatesName = 'nodeStates';
    static readonly settlementOverridePropertyName = 'SettlementAmount';
    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';
    static readonly claimStatusIdPropertyName = 'ClaimStatusId';

    static readonly KeyChars = {
        EnterKey: 13,
        EscKey: 27,
    };

    static maximumUploadSize: number = 104857600;
    static readonly maximumExcelUploadSize: number = 1000000;

    static remoteServiceBaseUrl: string;
    static remoteServiceBaseUrlFormat: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish
    static appBaseUrlFormat: string;
    static recaptchaSiteKey: string;
    static subscriptionExpireNootifyDayCount: number;

    // app insights settings
    static appInsightsInstrumentationKey: string;
    static readonly appInsightsCloudRoleName: string = "SDP.ServiceDeliveryUI";

    static localeMappings: any = [];

    static readonly maxLengths = {
        maxLengthZip: 5,
        maxLengthTextBox: 1024,
        maxLengthInput: 64
    }

    static readonly contactTypes = {
        generalManagerTypeConst: "Business",
        financeTypeConst: "Invoice",
        reportingTypeConst: "Reporting"
    }

    static readonly forecastPeriodTypes = {
        FirstForecastTypeConst: "Forecast Dec",
        SecondForecastTypeConst: "Forecast May",
        FinalSalesTypeConst: "Sale"
    }

    static readonly redemptionRecipientValidations = {
        maxPrimaryLicenseLength: 20,
        maxNameLength: 20,
        maxAddressLineLength: 35,
        maxCityLength: 50,
        maxStateLength: 2,
        maxPostalCodeLength: 5,
        maxPhoneLength: 11,
        maxRecipientNoteLength: 250,
        postalCodeLength: 5,
        NumberRegex: "^[0-9]*$"
    }

    static readonly licenseeValidations = {
        maxLengthName: 50,
        maxLengthAddress: 50,
        maxLengthFirstName: 50,
        maxLengthLastName: 50,
        maxEmailLength: 101,
        maxAccountIdLength: 15,
        requiredGLNLength: 13
    }

    static readonly regularExpressions = {
        noSpecialCharacters: "^[a-z|A-Z|0-9]*$",
        onlyNumerics: "^[0-9]*$",
        email: "(^$|^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$)",
        phoneNumber: "^((\\+0?1\\s)?\\(?\\d{3}\\)?[(\\s).-]?\\d{3}[(\\s).-]?\\d{4})?$",
        invalidPathAndFileCharacters: /[\.\<\>\?\*\:\\\/\"\|\:]/g,
        whitespaceCharacters: /\s/g,
        upperCaseCharacters: /(?=[A-Z])/,
        localizationRegex: /{(\d+)}/g,
        newLine: /\\n/g,
        tabCharacter: /\\t/g
    };

    static readonly LookupTypeDomains = LookupTypeDomains;

    static readonly addressTypes = {
        mainBranch: "Main Branch",
        mailTo: "Mail To"
    };

    static readonly organizationTypes = {
        Grower: "Grower",
        GrowerTypeId: 1,
        Distributor: "Distributor",
        DistributorTypeId: 2,
        Retailer: "Retailer",
        RetailerTypeId: 3
    }

    static readonly attachmentStatusTypes = {
        Created: "Created",
        Approved: "Approved",
        Sent: "Sent",
        Cancelled: "Cancelled"
    }


    static readonly userManagement = {
        defaultAdminUserName: 'admin',
    };

    static readonly accountManager = {
        defaultAccountManagerUserName: 'AccountManager'
    };


    static readonly localization = {
        defaultLocalizationSourceName: 'ServiceDelivery',
    };

    static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token',
    };

    static readonly grid = {
        defaultPageSize: 10,
    };

    static readonly MinimumUpgradePaymentAmount = 1;

    static readonly debounceTime = {
        default: 1500
    };

    static readonly claimStatusIds = {
        Draft: 1,
        PendingCalculation: 2,
        PendingApproval: 3,
        Approved: 4,
        Rejected: 5,
        Paid: 6,
        Cancelled: 7
    };

    static readonly claimStatus = {
        Draft: "Draft",
        PendingApproval: "Pending Approval",
        Approved: "Approved"
    };

    static readonly roleIds = {
        noRole: -1,
    };

    static readonly agdata: string = "AGDATA";
    static readonly maxPageSize: number = 1048575;
    static readonly addresses: string = "Addresses";
    static readonly countyHelper: string = "ZipCountyHelper";
    static readonly tenantNameCookie: string = "Abp_TenantName";
    static readonly tenantIdCookie: string = "Abp.TenantId";
    static readonly tenantNameRestriction: string = "sdp, localhost";
    static readonly hierarchyNoneId: number = 0;
    static readonly purchase: string = "purchase";

    static readonly claimsHierarchyDomainName: string = "Claims";

    static readonly maxAddresses = 50;

    static readonly subtotals = {
        GrossRoyalty: "GrossRoyalty",
        NetRoyalty: "NetRoyalty"
    };

    static readonly entityChangeProperties = {
        entityChangeTime: "entityChangeChangeTime",
    }

    static readonly pdfTypes = {
        Remittance: 0,
        PaymentConfirmation: 1
    };

    static readonly agcelerateProviderShortNames = {
        monsanto: "MON",
    };

    static readonly assetRelationshipTypes = {
        primary: 1,
        alternate: 2
    };

    static readonly assetTypes = {
        agcelerateLicense: 1,
        basfLicense: 2,
        bayerLicense: 3
    };

    static readonly assetTypeNames = {
        agcelerateLicense: "AgcelerateLicense",
        basfLicense: "BasfLicense",
        bayerLicense: "BayerLicense"
    };

    static readonly hierarchyDomainNames = {
        claims: "Claims",
        none: "None"
    };

    static readonly entityChangeTypes = {
        created: "Created",
        deleted: "Deleted",
        updated: "Updated"
    };

    static readonly userSettings = {
        company: "App.UserManagement.Company"
    }

    static readonly LicensedOrganizationClaimRestrictionTypes = {
        NoRestriction: 1,
        NotifyUser: 2,
        RestrictSubmission: 3
    };
    static readonly redemptionLoyaltyValidations = {
        maxEbidLength: 13,
        maxStateLength: 2,
    };

    /// <summary>
    /// Gets current version of the application.
    /// It's also shown in the web page.
    /// </summary>
    static readonly WebAppGuiVersion = '13.4.0';

    /// <summary>
    /// Redirects users to host URL when using subdomain as tenancy name for not existing tenants
    /// </summary>
    static readonly PreventNotExistingTenantSubdomains = false;
}
